import React from 'react'
import {
  LineChart,
  Line,
  Legend,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts'
import {
  ICreditUsageEntry,
  IProjectCreationEntry
} from '@SiteModules/Statistics/types'

type StatisticsData = ICreditUsageEntry[] | IProjectCreationEntry[]

interface StatisticsChartProps {
  readonly data: StatisticsData
  readonly valueKey: 'credits' | 'projectsCount'
  readonly label: string
}

// Formatter functions extracted
const formatDate = (date: string) => new Date(date).toLocaleDateString()
const formatValue = (value: number) => Math.round(value)

// Legend content extracted
const CustomLegendContent: React.FC<{ payload?: any[] }> = ({ payload }) => {
  if (!payload) {
    return null
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
      {payload.map((entry, index) => (
        <div
          key={index}
          style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}
        >
          {/* Line */}
          <span
            style={{
              display: 'inline-block',
              width: '24px',
              height: '2px',
              backgroundColor: entry.color,
              position: 'relative'
            }}
          >
            {/* Dot */}
            <span
              style={{
                display: 'block',
                width: '12px',
                height: '12px',
                backgroundColor: entry.color,
                borderRadius: '50%',
                position: 'absolute',
                top: '-5px',
                left: '6px'
              }}
            />
          </span>
          {/* Label */}
          <span style={{ color: entry.color, fontSize: '14px' }}>{entry.value}</span>
        </div>
      ))}
    </div>
  )
}

const StatisticsChart: React.FC<StatisticsChartProps> = ({
  data,
  valueKey,
  label
}) => (
  <ResponsiveContainer width="100%" height={300}>
    <LineChart data={data}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="date" tickFormatter={formatDate} />
      <YAxis />
      <Tooltip cursor={false} formatter={formatValue} />
      <Line
        type="monotone"
        dataKey={valueKey}
        name={label}
        stroke="rgba(153, 167, 249, 1)"
        strokeWidth={2}
        dot={{
          r: 6,
          fill: 'rgba(153, 167, 249, 1)',
          stroke: 'rgba(153, 167, 249, 1)',
          strokeWidth: 0
        }}
        activeDot={false}
      />
      <Legend verticalAlign="bottom" align="center" content={CustomLegendContent} />
    </LineChart>
  </ResponsiveContainer>
)

export default StatisticsChart
